import Vue from "vue";
  import { resolveRequestError } from "@/utils/auth";
  import * as ENDPOINTS from "./endpoints";

export default class TransactionService {
  /**
   *  Fetch wallet transactions
   *
   * @async
   * @return {Array}
   */
  static async getWalletTransactions(page = 1) {
    try {
      const { data } = await Vue.http.get(
        `${ENDPOINTS.TRANSACTIONS}?page=${page}`
      );
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  /**
   *  Fetch payouts
   *
   * @async
   * @return {Array}
   */
  static async getPayouts(page = 1) {
    try {
      const { data } = await Vue.http.get(`${ENDPOINTS.PAYOUTS}?page=${page}`);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async getFarmServices() {
    try {
      const { data } = await Vue.http.get(`${ENDPOINTS.FARM_SERVICES}`);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  // static async investFromWallet () {
  //   try {
  //     const { data } = await Vue.http.get(`${ENDPOINTS.INVEST_FROM_WALLET}`);
  //     return data;
  //   } catch (err) {
  //     resolveRequestError(err);
  //   }
  // }

  static async purchaseFarmAndFarm({
    reference,
    farmserviceid,
    plots,
    units,
    recurr,
    farmpackageid,
    requesttype,
    paymentmethod,
  }) {
    try {
      let form_json = {
        reference,
        requesttype,
        units,
        plots,
        recurr,
        farmpackageid,
        paymentmethod,
        farmserviceid,
      };

      const { data } = await Vue.http.post(ENDPOINTS.BUYFARM_PLANT, form_json);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async verify({
    reference,
    id,
    requesttype,
    subscriptionid,
    farmserviceid,
    units
  }) {
    try {
      let form_json = {
        requesttype,
        subscriptionid,
        farmserviceid,
        units
      };

      const { data } = await Vue.http.post(
        ENDPOINTS.VERIFY_TRANSACTION(reference, id),
        form_json
      );
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async toggleBalance() {
    try {
      const { data } = await Vue.http.post(ENDPOINTS.TOGGLE_BALANCE, {});
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async getBalanceStatus() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.BALANCE_STATUS);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async getActivePackages() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.GET_ACTIVE_PACKAGES);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async getSoldOutPackages() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.GET_SOLD_OUT_PACKAGES);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async searchRelatedEdibles(searchedData) {
    try {
      const { data } = await Vue.http.get(
        ENDPOINTS.SEARCH_EDIBLES(searchedData)
      );
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async manualPayment({
    packageid,
    reference,
    paymentproof,
    bankcode,
    requesttype,
    entity,
    units = 0,
    farmserviceid = 0,
    subscriptionid = 0,
  }) {
    try {
      let formData = new FormData();
      formData.append("paymentproof", paymentproof);
      formData.append("packageid", packageid);
      formData.append("reference", reference);
      formData.append("bankcode", bankcode);
      formData.append("requesttype", requesttype);
      formData.append("farmserviceid", farmserviceid);
      formData.append("subscriptionid", subscriptionid);
      formData.append("entity", entity);
      formData.append("units", units);
      const { data } = await Vue.http.post(ENDPOINTS.MANUAL_PAYMENT, formData);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async investFromWallet({ units, packageid }) {
    try {
      const { data } = await Vue.http.post(ENDPOINTS.INVEST_FROM_WALLET, {
        units,
        packageid,
      });
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async farmFromWallet({ units, farmserviceid, subscriptionid, packageid }) {
    try {
      const { data } = await Vue.http.post(ENDPOINTS.FARM_FROM_WALLET, {
        units,
        farmserviceid,
        subscriptionid,
        packageid
      });
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async getfarmserviceCost() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.GET_FARMSERVISE_COST);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async topUp(reference) {
    try {
      const { data } = await Vue.http.put(ENDPOINTS.TOPUP, { reference });
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async requestFarmPackage({
    farmpackageid,
    units,
    purpose,
    experiencelevel,
  }) {
    try {
      const { data } = await Vue.http.post(ENDPOINTS.REQUEST_PACKAGE, {
        units,
        farmpackageid,
        purpose,
        experiencelevel,
      });
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async getFarmPackages() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.FARM_PACKAGES);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async getEdibles() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.EDIBLES_PRODUCTS);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async initiatePayments() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.INITIATE_PAYMENT);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async getPaymentReference() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.EDIBLES_PRODUCTS);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async getPendingOrders() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.PENDING_EDIBLE_ORDERS);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async getOrderedProducts() {
    try {
      const { data } = await Vue.http.get(ENDPOINTS.ORDERED_EDIBLES_PRODUCTS);
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async getDeliveryCharge({ cart, city }) {
    try {
      const { data } = await Vue.http.post(ENDPOINTS.GET_DELIVERY_COST, {
        cart,
        city,
      });
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async orderProducts({
    reference,
    cart,
    address,
    paymentmethod,
    subscriptiontype,
  }) {
    try {
      const { data } = await Vue.http.post(ENDPOINTS.EDIBLES_PRODUCTS, {
        reference,
        cart,
        address,
        paymentmethod,
        subscriptiontype,
      });
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }

  static async ediblesManualPayment({
    reference,
    paymentproof,
    bankcode,
    address,
    cart,
    requesttype,
    subscriptiontype,
  }) {
    try {
      let formData = new FormData();
      formData.append("paymentproof", paymentproof);
      formData.append("reference", reference);
      formData.append("bankcode", bankcode);
      formData.append("address", JSON.stringify(address));
      formData.append("cart", JSON.stringify(cart));
      formData.append("requesttype", requesttype);
      formData.append("subscriptiontype", subscriptiontype);
      
      const { data } = await Vue.http.post(
        ENDPOINTS.EDIBLES_MANUAL_PAYMENT,
        formData
      );
      return data;
    } catch (err) {
      resolveRequestError(err);
    }
  }
}
